import React from 'react';

import { getConfig } from '@edx/frontend-platform';
import { Image } from '@openedx/paragon';

import { useT } from '../../../context/LanguageContext';

const ExtraSmallLayout = () => {
  const { t } = useT();

  return (
    <span
      className="w-100 bg-primary-500 banner__image extra-small-layout"
      style={{ backgroundImage: `url(${getConfig().BANNER_IMAGE_EXTRA_SMALL})` }}
    >
      <a href="/">
        <Image className="company-logo" alt={getConfig().SITE_NAME} src={getConfig().LOGO_WHITE_URL} />
      </a>
      <div className="ml-4.5 mr-1 pb-3.5 pt-3.5">
        <h1 className="banner__heading">
          <span className="text-light-500">
            {t('your.career.turning.point')}{' '}
          </span>
          <span className="text-warning-300">
            {t('is.here')}
          </span>
        </h1>
      </div>
    </span>
  );
};

export default ExtraSmallLayout;
